'use client';
import React, { useState } from 'react';
import { BoyIcon, GirlIcon } from './icons';
import { generateAlternativeGenderUrl } from '@/utils/seo';
import useLocalePath from '@/hooks/useLocalePath';
import { useTranslation } from '@/contexts/TranslationContext';

const GenderSelect = ({ formData, hashArray, onChange, isOnChange, isDisabled = false }) => {
  const localePath = useLocalePath();
  const { t } = useTranslation();

  // Wrap generateAlternativeGenderUrl to apply locale prefix.
  // The function may return an absolute URL — extract the path, prefix it.
  const getLocaleGenderUrl = (arr) => {
    const raw = generateAlternativeGenderUrl(arr);
    let path;
    try {
      path = new URL(raw).pathname;
    } catch {
      path = raw;
    }
    return localePath(path);
  };
  const [selectedGender, setSelectedGender] = useState(hashArray[2] === 'household' ? 'm' : formData.gender);

  const handleGenderChange = (e) => {
    onChange(e);
    setSelectedGender(e.target.value);
  };

  const handleRedirect = (e, gender) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (hashArray && !isOnChange && formData.gender !== gender) {
      e.preventDefault();
      window.location.href = getLocaleGenderUrl(hashArray);
    }
  };

  return (
    <div className="d-flex justify-content-center w-100 m-auto" style={{ maxWidth: '600px' }}>
      {/* Male Option */}
      <div className="d-flex flex-column align-items-center w-100">
        <label
          className={`main-checkbox m-auto w-100 ${selectedGender === 'm' ? 'checked' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          <input type="radio" name="gender" value="m" checked={selectedGender === 'm'} onChange={handleGenderChange} />
          <a
            href={!isDisabled && hashArray ? getLocaleGenderUrl(hashArray) : undefined}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              textDecoration: 'none',
              color: 'inherit',
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
            onClick={(e) => handleRedirect(e, 'm')}
          >
            <div className="d-flex align-items-center flex-column box">
              <div className="d-flex align-items-center">
                <div className="boy-radio circle-bg circle-bg-green ml-2">
                  <BoyIcon color={selectedGender === 'm' ? '#fff' : '#7C5032'} />
                </div>
                <span>{t('form.men')}</span>
              </div>
              <div className="bottom-line bottom-line-green" />
            </div>
          </a>
        </label>
      </div>

      {/* Female Option */}
      <div className="d-flex flex-column align-items-center w-100">
        <label
          className={`main-checkbox m-auto w-100 ${selectedGender === 'f' ? 'checked' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          <input type="radio" name="gender" value="f" checked={selectedGender === 'f'} onChange={handleGenderChange} />
          <a
            href={!isDisabled && hashArray ? getLocaleGenderUrl(hashArray) : undefined}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              textDecoration: 'none',
              color: 'inherit',
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
            onClick={(e) => handleRedirect(e, 'f')}
          >
            <div className="d-flex align-items-center flex-column box">
              <div className="d-flex align-items-center">
                <div className="girl-radio circle-bg circle-bg-green ml-2">
                  <GirlIcon color={selectedGender === 'f' ? '#fff' : '#7C5032'} />
                </div>
                <span>{t('form.women')}</span>
              </div>
              <div className="bottom-line bottom-line-green" />
            </div>
          </a>
        </label>
      </div>
    </div>
  );
};

export default GenderSelect;
